// extracted by mini-css-extract-plugin
export var copyableField = "_pr-4";
export var customerBadge = "_pr-0";
export var customerInfoTitle = "_pr-2";
export var details = "_pr-1";
export var dropdownContainer = "_pr-5";
export var dropdownImage = "_pr-6";
export var editAssigneeForm = "_pr-a";
export var editButton = "_pr-3";
export var email = "_pr-7";
export var hidden = "_pr-d";
export var input = "_pr-8";
export var saveButton = "_pr-b";
export var shopifyIcon = "_pr-c";
export var suggestionBadge = "_pr-e";
export var suggestionText = "_pr-f";
export var username = "_pr-9";